// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CorrectionReport, CorrectionReportSchema } from 'api/gen/CorrectionReport';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(CorrectionReportSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelCorrectionReportSchema = excess(requiredPart);

export interface PagedModelCorrectionReport extends t.TypeOf<typeof PagedModelCorrectionReportSchema> {}
